
<section class="container-fluid bg-white">
  <Table
    :data="this.filtertemplates || []"
    :columns="table.columns"
    :actionButton="table.actionButton"
    :disableSearch="false"
    :search="table.search"
    :actions="table.actions"
    @rowClicked="table.clickHandler"
  />
</section>
